import { PostProperties } from "../types";
import image from "../img/exposeTotenmet.jpg";

const post: PostProperties = {
  id: 4,
  title: "Exposé 04 - Totenmet",
  content:
    "Exposé 04 will showcase a plethora of mysterious sounds coming from Groningen, Netherlands. Bulgarian-born Totenmet presents us with an extensive amount of knowledge on how to build a proper mix. Read our interview for more insight.",
  image,
  buttonText: "Read More",
  buttonUrl: "expose-04-totenmet",
  category: "Expose",
  embedCode: `<iframe width="100%" height="600" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1464801661&color=%23ff5500&auto_play=false&hide_related=true&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/shubinproject" title="Shubin Project" target="_blank" style="color: #cccccc; text-decoration: none;">Shubin Project</a> · <a href="https://soundcloud.com/shubinproject/expose-04-totenmet" title="Exposé 04 - Totenmet" target="_blank" style="color: #cccccc; text-decoration: none;">Exposé 04 - Totenmet</a></div>`,
  questionsAndAnswers: [
    {
      question:
        "How would you define yourself? A connoisseur, a listener, a DJ, or something else?",
      answer: "A listener, mostly.",
    },
    {
      question: "What sparked your interest in electronic music?",
      answer:
        "My mum and sister used to listen to deep house and trance when I was young, and I think everything started from there. It wasn't until I had gone through all the other subgenres as a teenager that I heard techno and electro. That in turn led me to ambient, industrial, broken beat, downtempo, and in general the whole melting pot that is my taste today.",
    },
    {
      question: "How do you discover new music?",
      answer:
        "I mainly dig on Discogs, but YouTube also has good channels with an enormous variety of styles and artists (it's also the platform where you're most likely to find rips to listen to).",
    },
    {
      question:
        "What do you think are the most important changes in the scene in recent years?",
      answer: "DVS1's Aslice platform and the popularisation of Bandcamp.",
    },
    {
      question: "What inspired this mix? Was there any preparation beforehand?",
      answer:
        "This mix is considerably heavier and faster than what I usually do, but I wanted it to match what Shubin represents. And for me Shubin is: loud, energetic, rhythmic. My preparation mainly involves figuring out something suitable for the intro — after that it's whatever comes.",
    },
    {
      question: "Have you ever considered a career tied to music?",
      answer: "At night when I'm falling asleep, sometimes…",
    },
    {
      question: "What is the most memorable event you have attended?",
      answer:
        "Balkan Station 2020 — the first one I went to. To say the least, I was amazed by everything that happened over those two days!",
    },
    {
      question: "Favourite club/location?",
      answer:
        "Balkan Station. Nowhere else has people and an atmosphere quite like it.",
    },
    {
      question: "Favourite venue?",
      answer: "Underpool Arena",
    },
    {
      question: "Favourite track?",
      answer:
        "They change every month… this month it's Mr. Barth & Alexi Delano – Dutchmaster.",
    },
    {
      question: "Who are three important producers for you?",
      answer:
        "Drexciya, B12, and Basic Channel are the first that come to mind.",
    },
    {
      question: "Three important DJs?",
      answer:
        "A tough question, one I can't answer better than with my subjective opinion. If we focus on the word important — I'd say DVS1, Sterac, and Speedy J have contributed a great deal to the development of the global scene, and continue to do so even now in 2023.",
    },
  ],
  translationsBg: {
    content:
      "Exposé 04 ще ви представи изобилие от мистериозни звуци от Хрьонинген, Нидерландия. Роденият в България Totenmet ни демонстрира задълбочени познания как се изгражда правилен микс. Прочетете нашето интервю за по-задълбочено разбиране.",
    questionsAndAnswers: [
      {
        question:
          "Как определяш себе си? Ценител, слушател, диджей или нещо друго?",
        answer: "Слушател най-вече.",
      },
      {
        question: "Кое запали твоят интерес към електронната музика?",
        answer:
          "Майка ми и сестра ми слушаха дийп хаус и транс когато бях малък, и мисля че всичко тръгна от там. Едва след като минах през всички други поджанрове като тийнейджър  чух техно и електро. Това от своя страна ме доведе до амбиента, индъстриала, счупения бийт, даунтемпото, и изобщо към манджата с грозде която е вкуса ми днес.",
      },
      {
        question: "Как откриваш нова музика?",
        answer:
          "Главно ровя в Discogs, но и в Youtube има добри канали с огромно разнообразие от стилове и артисти (също така е платформата в която е най-вероятно да се намерят рипове за преслушване).",
      },
      {
        question:
          "Кои според теб са най-важните промени в сцената през последните години?",
        answer: "Аslice платформата на DVS1 и популяризирането на Bandcamp.",
      },
      {
        question:
          "Какво вдъхнови този микс? Имаше ли предварителна подготовка?",
        answer:
          "Този микс е доста по-тежък и бърз от обичайното за мен, но исках да бъде в тон с това което представлява Шубин. А за мен Шубин е : силно, раздвижено, ритмично. Подготовката за мен е най-вече да измисля нещо подходящо за интро. От там нататък е каквото сабя покаже.",
      },
      {
        question: "Обмислял ли си кариера обвързана с музиката?",
        answer: "Вечер когато заспивам, понякога…",
      },
      {
        question: "Кое е най-запомнящото се събитие, което си посещавал?",
        answer:
          "Balkan Station 2020 – първият на който отидох. Бях меко казано изумен от всичко което се случи през тези два дена!",
      },
      {
        question: "Любим клуб/локация?",
        answer: "Balkan Station. Никъде другаде няма подобни хора и атмосфера.",
      },
      {
        question: "Любима локация?",
        answer: "Underpool Arena",
      },
      {
        question: "Любим трак?",
        answer:
          "Сменят се през месец.. този месец е Mr. Barth & Alexi Delano – Dutchmaster.",
      },
      {
        question: "Кои за теб са трима важни продуценти?",
        answer:
          "Drexciya, B12 и Basic Channel са първите които ми идват на ум.",
      },
      {
        question: "Трима важни диджеи?",
        answer:
          "Сложен въпрос, на който нямам по-добър отговор от субективното ми мнение. Ако се фокусираме върху думата важни – бих казал че DVS1, Sterac и Speedy J са помогнали много за развитието на глобалната сцена, и продължават да го правят и сега в 2023г.",
      },
    ],
  },
};

export default post;
